<form [formGroup]="ObjGroupLines">
    <!-- Header -->
    <div class="card mb-3">
        <div class="card-body row">
            <div class="col-md-2">
                <label>Shortcode</label>
                <input class="form-control" formControlName="objGroupShortcode">
            </div>
            <div class="col-md-5">
                <label>Object Group Name</label>
                <input class="form-control" formControlName="objGroupName">
            </div>
            <div class="col-md-3">
                <label>Remarks</label>
                <input class="form-control" formControlName="objGroupRemarks">
            </div>
            <div class="col-md-2">
                <label>Group color (all lines)</label>
                <select class="form-control" formControlName="objGroupGroupColorFlag">
                    <option value=""></option>
                    <option value="Y">Y — alternate from template ColorGroup / FontColorGroup</option>
                    <option value="N">N</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Group layout (objgroupmaster) -->
    <div class="card mb-3 border-success">
        <div class="card-header bg-success bg-opacity-10 d-flex justify-content-between align-items-center">
            <strong>Group layout</strong>
            <button class="btn btn-sm btn-outline-success" type="button"
                (click)="groupVisibility.groupLayout = !groupVisibility.groupLayout">
                {{ groupVisibility.groupLayout ? 'Hide' : 'Show' }}
            </button>
        </div>
        <div class="card-body" *ngIf="groupVisibility.groupLayout">
            <p class="text-muted small mb-3">
                Layout applies to all elements in this group. Element rows below define content only
                (overlap offsets or optional size overrides).
            </p>
            <div class="row g-2 mb-3">
                <div class="col-md-3">
                    <label>X / centre (cms)</label>
                    <input class="form-control" formControlName="objGroupXpos" type="number" step="0.01">
                </div>
                <div class="col-md-3">
                    <label>Y / centre (cms)</label>
                    <input class="form-control" formControlName="objGroupYpos" type="number" step="0.01">
                </div>
                <div class="col-md-3">
                    <label>Width / item (cms)</label>
                    <input class="form-control" formControlName="objGroupWidth" type="number" step="0.01">
                </div>
                <div class="col-md-3">
                    <label>Height / item (cms)</label>
                    <input class="form-control" formControlName="objGroupHeight" type="number" step="0.01">
                </div>
            </div>
            <div class="row g-2">
                <div class="col-md-3">
                    <label>Overlap stack?</label>
                    <select class="form-control" formControlName="objGroupOverlapFlag">
                        <option value="">No — grid or circle</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Column-first?</label>
                    <select class="form-control" formControlName="objGroupGroupTraverseFlag">
                        <option value="">No — row-first</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Fixed cell size?</label>
                    <select class="form-control" formControlName="objGroupFixedSizeFlag">
                        <option value="">No — equal split</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Content align (sparse grid)</label>
                    <select class="form-control" formControlName="objGroupContentAlign">
                        <option *ngFor="let a of lineTextAligns" [value]="a">{{ a }}</option>
                    </select>
                    <small class="text-muted">Packs items in the group box when fewer than max rows/cols (e.g. 1 of 2 → CENTER-MIDDLE). Ignored if reverse, overlap, or circle. Prefer this over slide-type text align.</small>
                </div>
                <div class="col-md-3">
                    <label>Reverse direction?</label>
                    <select class="form-control" formControlName="objGroupRowReverseFlag">
                        <option value="">No</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Brick skew?</label>
                    <select class="form-control" formControlName="objGroupAlternateSkewFlag">
                        <option value="">No</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Max columns</label>
                    <input class="form-control" formControlName="objGroupMaxCols" type="number">
                </div>
                <div class="col-md-3">
                    <label>Max rows</label>
                    <input class="form-control" formControlName="objGroupMaxRows" type="number">
                </div>
                <div class="col-md-3">
                    <label>Circular placement?</label>
                    <select class="form-control" formControlName="objGroupCircleFlag">
                        <option value="">No — grid</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Circle radius (cms)</label>
                    <input class="form-control" formControlName="objGroupCircleRadius" type="number" step="0.01">
                </div>
                <div class="col-md-3">
                    <label>Arc start (deg)</label>
                    <input class="form-control" formControlName="objGroupCircleAngleStart" type="number" placeholder="-90">
                </div>
                <div class="col-md-3">
                    <label>Arc end (deg)</label>
                    <input class="form-control" formControlName="objGroupCircleAngleEnd" type="number" placeholder="90">
                </div>
                <div class="col-md-3">
                    <label>Full circle?</label>
                    <select class="form-control" formControlName="objGroupCircleFullFlag">
                        <option value="">No</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Rotate with radius?</label>
                    <select class="form-control" formControlName="objGroupCircleRotateFlag">
                        <option value="">No</option>
                        <option value="Yes">Yes</option>
                        <option value="Y">Y</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Radius skew / item (cms)</label>
                    <input class="form-control" formControlName="objGroupCircleRadiusSkew" type="number" step="0.01">
                </div>
            </div>
        </div>
    </div>

    <h5 class="mb-2">Group elements</h5>

    <!-- Group Visibility Toggles -->
    <div class="mb-2">
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group1 = !groupVisibility.group1"
            type="button">
            Content and Source
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group2 = !groupVisibility.group2"
            type="button">
            Shape Details
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group3 = !groupVisibility.group3"
            type="button">
            Text details
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group4 = !groupVisibility.group4"
            type="button">
            element color
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group5 = !groupVisibility.group5"
            type="button">
            element position / size
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group6 = !groupVisibility.group6"
            type="button">
            Animation
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group7 = !groupVisibility.group7"
            type="button">
            Auto
        </button>
    </div>

    <!-- Detail Rows -->
    <div formArrayName="details">
        <div *ngFor="let row of details.controls; let i = index" [formGroupName]="i" class="card mb-3 border-primary">
            <div class="card-body">
                <div class="row align-items-center mb-2">
                    <div class="col-md-1"><strong>{{ i + 1 }}</strong></div>
                    <div class="col-md-4">
                        <select class="form-control" formControlName="OGType">
                            <option value="">Select Type</option>
                            <option *ngFor="let type of ogTypes" [value]="type.ValidVal">{{ type.ValidVal }}</option>
                        </select>
                    </div>
                       <div class="col-md-4">
                                <label>Line Name</label>

                                <input class="form-control" formControlName="OGName">
                            </div>
                         
                    <div class="col-md-4">
                        <button class="btn btn-sm btn-secondary" (click)="moveUp(i)" type="button">▲</button>
                        <button class="btn btn-sm btn-secondary" (click)="moveDown(i)" type="button">▼</button>
                        <button class="btn btn-sm btn-danger" (click)="deleteRow(i)" type="button">🗑</button>
                    </div>
                </div>
                <div class="d-flex flex-row flex-wrap gap-3">
                    <!-- Group 1 Card -->
                    <!--div *ngIf="groupVisibility.group1" formGroupName="group1" class="card p-2 flex-fill"-->
                    <div *ngIf="groupVisibility.group1"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Content & Source</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Value / filename</label>

                                <input class="form-control" formControlName="OGVal">
                            </div>
                            
                            <div class="col-md-16">
                                <label>Source Type</label>
                                <select class="form-control" formControlName="OGSourceType">
                                    <option value="">Select Source Type</option>
                                    <option *ngFor="let sourcetype of sourceTypes" [value]="sourcetype.ValidVal">{{
                                        sourcetype.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16 mt-2">
                                <label>Allow translate</label>
                                <select class="form-control" formControlName="OGAllowTranslate">
                                    <option value="Y">Y — translate with AI</option>
                                    <option value="N">N — keep English as-is (e.g. page no)</option>
                                </select>
                            </div>
                            <div class="col-md-16 mt-2">
                                <label>Text break (seed soft-break)</label>
                                <input class="form-control" type="number" formControlName="OGTextBreak" min="0" step="1"
                                    placeholder="blank/0=off; 1=auto from width; &gt;1=max chars" />
                                <small class="text-muted">Newlines always split at seed. Soft-break by length only when set.</small>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="groupVisibility.group7" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Automation</div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label>Auto source</label>
                                    <select class="form-control" formControlName="OGAutoSource">
                                        <option value="">—</option>
                                        <option *ngFor="let s of lineAutoSources" [value]="s">{{ s }}</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label>Auto value</label>
                                    <input class="form-control" formControlName="OGAutoVal" maxlength="45" />
                                </div>
                                <div class="col-md-4">
                                    <label>Auto condition</label>
                                    <select class="form-control" formControlName="OGAutoCondition">
                                        <option value="">—</option>
                                        <option *ngFor="let c of lineAutoConditions" [value]="c">{{ c }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto entry before → PSL show with</label>
                                    <select class="form-control" formControlName="OGAutoEntryBefore">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('OGAutoEntryBefore')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto entry after → PSL show after</label>
                                    <select class="form-control" formControlName="OGAutoEntryAfter">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('OGAutoEntryAfter')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto exit before → PSL exit with</label>
                                    <select class="form-control" formControlName="OGAutoExitBefore">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('OGAutoExitBefore')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto exit after → PSL exit after</label>
                                    <select class="form-control" formControlName="OGAutoExitAfter">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('OGAutoExitAfter')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Group 2 Card -->
                    <div *ngIf="groupVisibility.group2"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Shape</div>
                        <div class="card-body">

                            <div class="col-md-16">
                                <label>Shape Type</label>
                                <select class="form-control" formControlName="OGShapeType">
                                    <option value="">Select Shape Type</option>
                                    <option *ngFor="let shapeType of shapeTypes" [value]="shapeType.ValidVal">{{
                                        shapeType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Shape Border</label>
                                <select class="form-control" formControlName="OGShapeBorder">
                                    <option value="">Select border Type</option>
                                    <option *ngFor="let shapeBorderType of shapeBorderTypes" [value]="shapeBorderType.ValidVal">{{
                                        shapeBorderType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Shape Fill</label>
                                <input class="form-control" formControlName="OGShapeFill">
                            </div>
                            <div class="col-md-16">
                                <label>Shape Shadow</label>
                                <select class="form-control" formControlName="OGShapeShadow">
                                     <option value="">Select border Type</option>
                                    <option *ngFor="let shapeShadowType of shapeShadowTypes" [value]="shapeShadowType.ValidVal">{{
                                        shapeShadowType.ValidVal }}</option>
                                </select>
                            </div>

                        </div>
                    </div>


                    <!-- Group 3 Card -->
                    <div *ngIf="groupVisibility.group3"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Text</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Text Align</label>
                                <select class="form-control" formControlName="OGtextAlign">
                                    <option value="">Select </option>
                                    <option *ngFor="let textalignType of textalignTypes"
                                        [value]="textalignType.ValidVal">{{
                                        textalignType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Text Font</label>
                                <input class="form-control" formControlName="OGTextFont">
                            </div>
                            <div class="col-md-16">
                                <label>Reading material</label>
                                <select class="form-control" formControlName="ReadingMaterial">
                                    <option value="">— skip —</option>
                                    <option *ngFor="let rmType of readingMaterialSelectOptions(row.get('ReadingMaterial')?.value)" [value]="rmType.ValidVal">{{ rmType.ValidVal }}</option>
                                </select>
                                    <small class="text-muted">Style from template ReadingMaterial rows, Image to include a picture, or N to skip.</small>
                            </div>
                            <div class="col-md-16">
                                <label>Text Color</label>
                                <input class="form-control" formControlName="OGTextColor">
                            </div>
                            <div class="col-md-16">
                                <label>Is bulleted?</label>
                                <select class="form-control" formControlName="OGBulletFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Bullet size</label>
                                <input class="form-control" formControlName="OGBulletSize">
                            </div>
                            <div class="col-md-16">
                                <label>Bullet Character</label>
                                <input class="form-control" formControlName="OGBulletCharacter">
                            </div>
                            <div class="col-md-16">
                                <label>Text style for Numbers</label>
                                <input class="form-control" formControlName="OGNumTextStyle">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="groupVisibility.group4" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Element color</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Use group color for this element?</label>
                                <select class="form-control" formControlName="OGGroupColorFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="groupVisibility.group5" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Element position / size</div>
                        <div class="card-body">
                            <p class="text-muted small">Overlap mode: offset from group X/Y. Grid/circle: optional size override.</p>
                            <div class="col-md-16">
                                <label>X offset (cms)</label>
                                <input class="form-control" formControlName="OGXpos" type="number" step="0.01">
                            </div>
                            <div class="col-md-16">
                                <label>Y offset (cms)</label>
                                <input class="form-control" formControlName="OGYpos" type="number" step="0.01">
                            </div>
                            <div class="col-md-16">
                                <label>Width override (cms)</label>
                                <input class="form-control" formControlName="OGWidth" type="number" step="0.01">
                            </div>
                            <div class="col-md-16">
                                <label>Height override (cms)</label>
                                <input class="form-control" formControlName="OGHeight" type="number" step="0.01">
                            </div>
                        </div>
                    </div>

                    <!-- Group 6 Card -->
                    <div *ngIf="groupVisibility.group6" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Animation</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Entry animation type</label>
                                <select class="form-control" formControlName="OGEntryAnimType">
                                    <option value="">Select </option>
                                    <option *ngFor="let entryanimType of entryanimTypes"
                                        [value]="entryanimType.ValidVal">{{
                                        entryanimType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Exit animation type</label>
                                <select class="form-control" formControlName="OGExitAnimType">
                                    <option value="">Select </option>
                                    <option *ngFor="let exitanimType of exitanimTypes" [value]="exitanimType.ValidVal">
                                        {{
                                        exitanimType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Animation time</label>
                                <input class="form-control" formControlName="OGExitAnimTime">
                            </div>
                            <div class="col-md-16">
                                <label>Is previous button?</label>
                                <select class="form-control" formControlName="OGPreviousFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Is next button?</label>
                                <select class="form-control" formControlName="OGNextFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Is replay button?</label>
                                <select class="form-control" formControlName="OGReplayFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-3">
        <button type="button" class="btn btn-outline-primary" (click)="addRow()">➕ Add Row</button>
    </div>

    <div class="text-end">
        <button type="button" class="btn btn-success" (click)="saveOG()">💾 Save</button>
    </div>

</form>